<p-toast></p-toast>

<div class="fluid formgrid grid p-4">
    <!-- Informations de base du rôle -->
    <div class="col-12">
            <h6 class="mb-3">Informations générales</h6>
            <div class="fluid formgrid grid">
                <div class="flex flex-column gap-2 my-2 col-12">
                    <label for="nomRole" class="font-semibold">Nom du rôle *</label>
                    <input id="nomRole" type="text" pInputText [(ngModel)]="role.nom"
                        [disabled]="role.nom === 'SIHC_Administrateur'" class="w-full"
                        placeholder="Entrez le nom du rôle"
                        [class.ng-invalid]="submitted && (!role.nom || role.nom.trim() === '')" maxlength="100" />
                    <small *ngIf="submitted && (!role.nom || role.nom.trim() === '')" class="p-error">Le nom du rôle est
                        obligatoire.</small>
                    <small *ngIf="role.nom === 'SIHC_Administrateur'" class="p-info">Le nom du rôle administrateur ne
                        peut pas être modifié.</small>
                </div>
            </div>
    </div>

    <!-- Gestion des tâches -->
    <div class="col-12 my-4">
            <h6 class="mb-3 w-full text-center">
                <i class="pi pi-cog mr-2"></i>
                Tâches associées ({{tachesSelectionnees.length}})
                <p-tag
                    *ngIf="hasModifications() && (getTachesAjoutees().length > 0 || getTachesSupprimees().length > 0)"
                    value="Modifié" severity="warning" class="ml-2"></p-tag>
            </h6>

            <!-- Indicateurs de changements pour les tâches -->
            <div *ngIf="modeEdition && hasModifications()" class="mb-3">
                <div *ngIf="getTachesAjoutees().length > 0" class="mb-2">
                    <small class="text-green-600 font-semibold">
                        <i class="pi pi-plus-circle mr-1"></i>
                        Tâches à ajouter ({{getTachesAjoutees().length}}):
                    </small>
                    <div class="mt-1">
                        <p-chip *ngFor="let tache of getTachesAjoutees()" [label]="tache.nom"
                            styleClass="mr-1 mb-1 p-chip-success"></p-chip>
                    </div>
                </div>
                <div *ngIf="getTachesSupprimees().length > 0" class="mb-2">
                    <small class="text-red-600 font-semibold">
                        <i class="pi pi-minus-circle mr-1"></i>
                        Tâches à supprimer ({{getTachesSupprimees().length}}):
                    </small>
                    <div class="mt-1">
                        <p-chip *ngFor="let tache of getTachesSupprimees()" [label]="tache.nom"
                            styleClass="mr-1 mb-1 p-chip-danger"></p-chip>
                    </div>
                </div>
            </div>

            <p-pickList [source]="tachesDisponibles" [target]="tachesSelectionnees" sourceHeader="Tâches disponibles"
                targetHeader="Tâches assignées" [dragdrop]="true" [responsive]="true" [sourceStyle]="{'height':'300px'}"
                [targetStyle]="{'height':'300px'}" filterBy="nom" sourceFilterPlaceholder="Rechercher une tâche..."
                targetFilterPlaceholder="Rechercher une tâche...">

                <ng-template let-tache pTemplate="item">
                    <div class="flex align-items-center gap-2 p-2">
                        <i class="pi pi-cog text-primary"></i>
                        <div class="flex flex-column">
                            <span class="font-semibold">{{tache.nom}}</span>
                            <small class="text-color-secondary">{{tache.code}}</small>
                        </div>
                        <!-- Indicateurs visuels pour les changements -->
                        <div class="ml-auto">
                            <i *ngIf="isTacheAjoutee(tache)" class="pi pi-plus-circle text-green-600"
                                pTooltip="Sera ajoutée au rôle"></i>
                            <i *ngIf="isTacheSupprimee(tache)" class="pi pi-minus-circle text-red-600"
                                pTooltip="Sera supprimée du rôle"></i>
                        </div>
                    </div>
                </ng-template>
            </p-pickList>
    </div>

    <!-- Gestion des employés -->
    <div class="col-12 my-4">
            <h6 class="mb-3 w-full text-center">
                <i class="pi pi-users mr-2"></i>
                Employés assignés ({{employesSelectionnes.length}})
                <p-tag
                    *ngIf="hasModifications() && (getEmployesAjoutes().length > 0 || getEmployesSupprimes().length > 0)"
                    value="Modifié" severity="warning" class="ml-2"></p-tag>
            </h6>

            <!-- Indicateurs de changements pour les employés -->
            <div *ngIf="modeEdition && hasModifications()" class="mb-3">
                <div *ngIf="getEmployesAjoutes().length > 0" class="mb-2">
                    <small class="text-green-600 font-semibold">
                        <i class="pi pi-plus-circle mr-1"></i>
                        Employés à ajouter ({{getEmployesAjoutes().length}}):
                    </small>
                    <div class="mt-1">
                        <p-chip *ngFor="let employe of getEmployesAjoutes()"
                            [label]="employe.prenom + ' ' + employe.nom" styleClass="mr-1 mb-1 p-chip-success"></p-chip>
                    </div>
                </div>
                <div *ngIf="getEmployesSupprimes().length > 0" class="mb-2">
                    <small class="text-red-600 font-semibold">
                        <i class="pi pi-minus-circle mr-1"></i>
                        Employés à supprimer ({{getEmployesSupprimes().length}}):
                    </small>
                    <div class="mt-1">
                        <p-chip *ngFor="let employe of getEmployesSupprimes()"
                            [label]="employe.prenom + ' ' + employe.nom" styleClass="mr-1 mb-1 p-chip-danger"></p-chip>
                    </div>
                </div>
            </div>

            <p-pickList [source]="employesDisponibles" [target]="employesSelectionnes"
                sourceHeader="Employés disponibles" targetHeader="Employés assignés" [dragdrop]="true"
                [responsive]="true" [sourceStyle]="{'height':'300px'}" [targetStyle]="{'height':'300px'}"
                filterBy="nom,prenom" sourceFilterPlaceholder="Rechercher un employé..."
                targetFilterPlaceholder="Rechercher un employé...">

                <ng-template let-employe pTemplate="item">
                    <div class="flex align-items-center gap-2 p-2">
                        <i class="pi pi-user text-primary"></i>
                        <div class="flex flex-column">
                            <span class="font-semibold">{{employe.prenom}} {{employe.nom}}</span>
                            <small class="text-color-secondary">{{employe.courriel}}</small>
                        </div>
                        <!-- Indicateurs visuels pour les changements -->
                        <div class="ml-auto flex align-items-center gap-2">
                            <span (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                                <p-button icon="pi pi-info-circle" size="small"
                                    pTooltip="Voir les rôles de l'employé" (onClick)="voirRolesEmploye($event, employe)"></p-button>
                            </span>
                            <i *ngIf="isEmployeAjoute(employe)" class="pi pi-plus-circle text-green-600"
                                pTooltip="Sera ajouté au rôle"></i>
                            <i *ngIf="isEmployeSupprime(employe)" class="pi pi-minus-circle text-red-600"
                                pTooltip="Sera supprimé du rôle"></i>
                        </div>
                    </div>
                </ng-template>
            </p-pickList>
    </div>
</div>

<!-- Boutons d'action -->
<div class="my-2">
    <!-- Résumé des modifications -->
    <div *ngIf="modeEdition && hasModifications()" class="mb-3 p-3 border-round surface-100">
        <h6 class="mb-2">
            <i class="pi pi-info-circle mr-2 text-orange-600"></i>
            Résumé des modifications à appliquer:
        </h6>
        <ul class="list-none p-0 m-0">
            <li *ngIf="getTachesAjoutees().length > 0" class="mb-1">
                <i class="pi pi-plus-circle text-green-600 mr-2"></i>
                <strong>{{getTachesAjoutees().length}}</strong> tâche(s) seront ajoutées
            </li>
            <li *ngIf="getTachesSupprimees().length > 0" class="mb-1">
                <i class="pi pi-minus-circle text-red-600 mr-2"></i>
                <strong>{{getTachesSupprimees().length}}</strong> tâche(s) seront supprimées
            </li>
            <li *ngIf="getEmployesAjoutes().length > 0" class="mb-1">
                <i class="pi pi-plus-circle text-green-600 mr-2"></i>
                <strong>{{getEmployesAjoutes().length}}</strong> employé(s) seront ajoutés
            </li>
            <li *ngIf="getEmployesSupprimes().length > 0" class="mb-1">
                <i class="pi pi-minus-circle text-red-600 mr-2"></i>
                <strong>{{getEmployesSupprimes().length}}</strong> employé(s) seront supprimés
            </li>
        </ul>
    </div>

    <div class="flex justify-content-end gap-2 pt-3">
        <button pButton pRipple label="Annuler" icon="pi pi-times" class="p-button-secondary" (click)="annuler()"
            [disabled]="chargementEnCours">
        </button>
        <button pButton pRipple
            [label]="modeEdition ? (hasModifications() ? 'Appliquer les modifications' : 'Modifier') : 'Créer'"
            [icon]="modeEdition ? 'pi pi-pencil' : 'pi pi-plus'"
            [class]="hasModifications() ? 'p-button-warning' : 'p-button-success'" (click)="sauvegarder()"
            [loading]="chargementEnCours">
        </button>
    </div>
</div>

<p-dialog header="Rôles de l'employé" [(visible)]="afficherDialogueRolesEmploye" [style]="{width: '50vw'}"
    [modal]="true" [closable]="true">
    <p-table *ngIf="afficherDialogueRolesEmploye" [value]="employe.roles">
        <ng-template pTemplate="header">
            <tr>
                <th>Nom</th>
                <th>Description</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-role>
            <tr>
                <td>{{role.nom}}</td>
                <td>{{role.description}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>